(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('EditSoopController', EditSoopController);

    EditSoopController.$inject = ['$rootScope','$sce','$controller', '$uibModalInstance', 'entity', 'parameters', 'SoopkitchenUtils', 'Planning', 'SoopService'];

    function EditSoopController($rootScope, $sce, $controller, $uibModalInstance, entity, parameters, SoopkitchenUtils, Planning, SoopService) {

        var vm = this;
        var title = 'Update SOOP' + parameters.soopType + ': <span class="label label-info">' + parameters.encodedSoopType + '_' + parameters.soopInstanceId + '</span>';
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance:$uibModalInstance}));
        
        /**** Properties ****/
        vm.plan = entity;
        vm.planLabel =  parameters.planLabel;
        vm.soopInstanceId=  parameters.soopInstanceId;
        vm.encodedSoopType=  parameters.encodedSoopType;
        vm.anchorTime =  parameters.anchorDate;
        vm.planType =  parameters.planType;
        vm.soopType =  parameters.soopType;
        
        //Overriding Properties from SoopkitchenDialogController:
        vm.deleteText = "Delete";
        vm.saveDisabled = false;

        /**** Methods ****/
        vm.isValidDate = isValidDate;
        
        //Override Methods from SoopkitchenDialogController
        vm.delete = deleteSoop;
        vm.save = moveSoop;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function isValidDate(date) {
            if (date === null || date    === '') {
                vm.saveDisabled = true;
                return false;
            }
            vm.saveDisabled = SoopkitchenUtils.isValidDate(date) === false;
            return SoopkitchenUtils.isValidDate(date);
        }

        function successCallback(response) {
            return function() {
                vm.waiting = false;
                SoopkitchenUtils.updatePlanFromDialog(response.data);
                $uibModalInstance.dismiss('cancel');
            }
        }

        function extraErrorCallback() {
            vm.waiting = false;
        }
        
        function moveSoop() {
            vm.waiting = true;
            SoopService.moveSoop(vm.planType, vm.planLabel, vm.soopInstanceId, vm.encodedSoopType, vm.soopType, vm.anchorTime, true, successCallback, extraErrorCallback)
        }
        
        function deleteSoop() {
            var title = "Delete SOOP";
            var text = "Do you really want to delete the SOOP of type "+ vm.encodedSoopType +  " and soopInstanceId "+vm.soopInstanceId
                +"?";
            vm.waiting = true;
            var callback = function() {
                Planning.deleteSoop(
                    {
                        planType: vm.planType,
                        planLabel: vm.planLabel,
                        soopInstanceId:  vm.soopInstanceId,
                        encodedSoopType: vm.encodedSoopType
                    },
                    function successCallback(data) {
                        SoopkitchenUtils.updatePlanFromDialog(data);
                        vm.waiting = false;
                        $uibModalInstance.dismiss('cancel');

                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                        vm.waiting = false;
                    });
            };

            SoopkitchenUtils.prettyConfirm(title, text, callback);
        }

    }
})();
